import { Avatar, Badge, Flex, Text } from "@chakra-ui/react";

const STATISTICAL_REPORT_STATUS_ENUM = {
  OUTSTANDING: "XUAT_SAC", // blue
  ACHIEVED: "DAT", // green
  WARNING: "CANH_BAO", // yellow
  CRITICAL_WARNING: "CANH_BAO_DO", // red
  NEEDS_SUPPORT: "CAN_HO_TRO", // purple
  UNCLASSIFIED: "CHUA_XEP_LOAI", // gray
};

const CLASSIFICATION_STYLE_MAP = {
  [STATISTICAL_REPORT_STATUS_ENUM.OUTSTANDING]: {
    label: "Xuất sắc",
    color: "blue",
  },
  [STATISTICAL_REPORT_STATUS_ENUM.ACHIEVED]: {
    label: "Đạt",
    color: "green",
  },
  [STATISTICAL_REPORT_STATUS_ENUM.WARNING]: {
    label: "Cảnh báo",
    color: "yellow",
  },
  [STATISTICAL_REPORT_STATUS_ENUM.CRITICAL_WARNING]: {
    label: "Cảnh báo đỏ",
    color: "red",
  },
  [STATISTICAL_REPORT_STATUS_ENUM.NEEDS_SUPPORT]: {
    label: "Cần hỗ trợ",
    color: "purple",
  },
  [STATISTICAL_REPORT_STATUS_ENUM.UNCLASSIFIED]: {
    label: "Chưa xếp loại",
    color: "gray",
  },
};

const formatClassification = (value) => {
  const config =
    CLASSIFICATION_STYLE_MAP[value] ||
    CLASSIFICATION_STYLE_MAP[STATISTICAL_REPORT_STATUS_ENUM.UNCLASSIFIED];

  return (
    <Badge
      colorScheme={config.color}
      variant="subtle"
      px={3}
      py={1}
      borderRadius="full"
      fontSize="12px"
      fontWeight="600"
      textTransform="none"
      whiteSpace="nowrap"
    >
      {config.label}
    </Badge>
  );
};

export const formatTableValue = (value, key, handleNavigate) => {
  switch (key) {
    case "contact": {
      const infos = value?.split("-") || [];

      return (
        <Flex direction="column" justifyContent="left">
          {infos?.length
            ? infos.map((item, index) => <Text key={index}>{item}</Text>)
            : null}
        </Flex>
      );
    }

    case "avatar":
      return <Avatar src={value} />;

    case "name":
      return (
        <Text
          onClick={() => handleNavigate?.()}
          cursor="pointer"
          fontWeight="500"
          _hover={{
            color: "var(--color-option-employee-hover)",
            textDecoration: "underline",
          }}
        >
          {value}
        </Text>
      );

    case "classification":
      return formatClassification(value);

    default:
      return <Text>{value}</Text>;
  }
};

export const formatTableValueV2 = (value, key, submit, id) => {
  switch (key) {
    case "avatar":
      return <Avatar src={value} />;

    case "classification":
      return formatClassification(value);

    default:
      return <Text>{value}</Text>;
  }
};